module.exports = __webpack_public_path__ + "img/logo-blue.e8d172ec.svg";